import { render, staticRenderFns } from "./bookListRecord.vue?vue&type=template&id=edfdc4f2&scoped=true&"
import script from "./bookListRecord.vue?vue&type=script&lang=js&"
export * from "./bookListRecord.vue?vue&type=script&lang=js&"
import style0 from "./bookListRecord.vue?vue&type=style&index=0&id=edfdc4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfdc4f2",
  null
  
)

export default component.exports